import { render, staticRenderFns } from "./articlePublish.vue?vue&type=template&id=d0f280b4&scoped=true&"
import script from "./articlePublish.vue?vue&type=script&lang=js&"
export * from "./articlePublish.vue?vue&type=script&lang=js&"
import style0 from "./articlePublish.vue?vue&type=style&index=0&id=d0f280b4&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d0f280b4",
  null
  
)

export default component.exports